// extracted by mini-css-extract-plugin
export default {"btnChangeResponsible":"absencePull_btnChangeResponsible__uW35g","changeResponsible":"absencePull_changeResponsible__p9D4L"};